<template>
	<el-card class="box-card"  style="margin-top: 20px">
	  <div slot="header" class="clearfix">
	    <span>年度发文趋势</span>
	  </div>
	  <div id="yearChart" ref="yearChart" :style="{width: '100%', height: '230px'}"></div>
	</el-card>
</template>

<script>
	export default {
		name: "yearChart",
		data(){
			return{
				
			}
		},
		methods:{
			yearChart(){
				let option = {
					title: {
						text: ''
					},
					tooltip : {
						trigger: 'axis',
						axisPointer : {            // 坐标轴指示器，坐标轴触发有效
							type : 'line'        // 默认为直线，可选为：'line' | 'shadow'
						}
					},
					legend: {
						data:['年度发文趋势']
					},
					grid: {
						left: '0%',
						right: '0%',
						top: '10%',
						bottom: '3%',
						containLabel: true
					},
					xAxis : [
						{
							type : 'category',
							data : ["2015","2016","2017","2018","2019","2020"]
						}
					],
					yAxis : [
						{
							type : 'value'
						}
					],
					series : [
						{
							name:'年度发文趋势',
							type:'bar',
							data: [0.7,1.1,1,0.3,0.6,0],
							barWidth :30,
							itemStyle:{
								normal:{
									color:function(params) {
										// build a color map as your need.
										var colorList = [
											'#C1232B','#B5C334','#FCCE10','#E87C25','#27727B',
											'#FE8463','#9BCA63','#FAD860','#F3A43B','#60C0DD',
											'#D7504B','#C6E579','#F4E001','#F0805A','#26C0C0'
										];
										return colorList[params.dataIndex]
									}
								}
							},
						}


					]
				};
				let yearChart = this.$echarts.init(document.getElementById('yearChart'));
				yearChart.setOption(option);
			}
		},
		mounted() {
			this.yearChart();
		}

	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/year-chart.vue